// The mark: a triangle split into two shards by one diagonal gap. Drawn rather
// than loaded as an image so it stays crisp at any size and inverts with the
// theme for free. The tile is --accent and the glyph --bg, so the tile always
// stands off the page: in dark it is the favicon — ink prism on a paper tile —
// and in light the inverse, a paper prism on an ink tile.
//
// Path data is identical to ios/design/icon/svg/prisma-prism-mark-*.svg and to
// the PNGs in public/. If the mark changes, change it in all three.
const SHARDS = [
  'M512.0 204.8 L671.88 513.9 L242.32 726.17 Z',
  'M733.05 632.16 L819.2 798.72 L396.0 798.72 Z',
];

export function AppLogo({ size = 22, className, style }) {
  return (
    <span
      role="img"
      aria-label="Prisma"
      className={className}
      style={{
        width: size,
        height: size,
        borderRadius: Math.round(size * 0.225),
        background: 'var(--accent)',
        display: 'block',
        flexShrink: 0,
        overflow: 'hidden',
        ...style,
      }}
    >
      <svg viewBox="0 0 1024 1024" width={size} height={size} style={{ display: 'block' }} aria-hidden="true">
        {SHARDS.map((d) => (
          <path
            key={d}
            d={d}
            fill="var(--bg)"
            stroke="var(--bg)"
            strokeWidth="61.44"
            strokeLinejoin="round"
            strokeLinecap="round"
          />
        ))}
      </svg>
    </span>
  );
}
